import { PriceObject } from '../ProductDetails/ProductPrice';
import { formatPrice } from 'helpers/currency';

export const getMobileTestCTALabel = (price: PriceObject): string => {
  const displayPrice = price.strikethroughPrice || price.productPriceTotal;
  return `CUSTOMIZE | ${formatPrice(displayPrice, { simplifyDigits: true })}`;
};
